module.exports = __webpack_public_path__ + "fdc3a543c865e335872c15e69427a29f.pdf";